import React from 'react';

import { useIntl } from 'react-intl';

import { tableMessages as messages } from '@atlaskit/editor-common/messages';
import { TableCellMergeIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';

export const MergeCellsItem = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<ToolbarDropdownItem elemBefore={<TableCellMergeIcon label="" size="small" />}>
			{formatMessage(messages.mergeCells)}
		</ToolbarDropdownItem>
	);
};
